import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/kakobuy-sheet-kompletny-przewodnik/page";
import CSSBuyArticle from "@/pages/article/cssbuy-spreadsheet-vs-kakobuy/page";
import SuperbuyArticle from "@/pages/article/superbuy-spreadsheet-przewodnik/page";
import OopbuyArticle from "@/pages/article/oopbuy-spreadsheet-przewodnik/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-sheet-kompletny-przewodnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/cssbuy-spreadsheet-vs-kakobuy",
    element: <CSSBuyArticle />,
  },
  {
    path: "/artykul/superbuy-spreadsheet-przewodnik",
    element: <SuperbuyArticle />,
  },
  {
    path: "/artykul/oopbuy-spreadsheet-przewodnik",
    element: <OopbuyArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;